module.exports = __webpack_public_path__ + "static/media/07-icon.73aaa58a.svg";